import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import demoData from '../../demoData/projectsData.json';
import Navbar from '../Navbar/Navbar';
import './AllProjects.css';
import AllProjectsInfo from './AllProjectsInfo';

const AllProjects = () => {
    const [projects, setProjects] = useState([]);
    const [visible, setVisible] = useState(9);
    const allProjects = projects.slice(0, visible);

    useEffect(() => {
        setProjects(demoData)
    }, [])

    const loadMoreProject =  () => {
        setVisible(previousProjects => previousProjects + 6)
    };
    
    return (
        <div>
            <Navbar></Navbar>
            <div className="container project">
                <div className="project-section">
                    <h1 className="text-center mb-4 pb-4">My Projects</h1>
                    <div className="card-group row">
                        {
                            allProjects.map(project => <AllProjectsInfo project={project} key={project.id}></AllProjectsInfo>)
                        }
                    </div>

                    <div className="text-center">
                        {visible === allProjects.length &&
                            <Link onClick={loadMoreProject} to="#" className="btn btn-outline-custom px-3 mt-4 fw-bold text-white">See More</Link>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllProjects;